import React, { useEffect, useState } from "react";
import {
  getDecryptedAccessToken,
  getDecryptedData,
  getDecryptedUserType,
} from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
import ApiServices from "../../../Utils/ApiServices/ApiServices";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  MenuItem,
  Box,
  Divider,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Chip,
} from "@mui/material";
import { Add, Close, CheckCircle, HourglassEmpty, Cancel, Event, AccessTime } from "@mui/icons-material";
import BookAppointment from "./BookAppointment";
import { useNavigate, useParams } from "react-router-dom";

const statusIcons = {
  "^": <HourglassEmpty color="warning" />, // Pending
  APPR: <CheckCircle color="success" />, // Approved
  REJ: <Cancel color="error" />, // Rejected
};

const statusLabels = {
  "^": "Pending",
  APPR: "Approved",
  REJ: "Rejected",
};

const AllBookedAppointments = ({onAppointmentsClick}) => {
  const accessToken = getDecryptedAccessToken();
  const loginUserType = getDecryptedUserType();
  const loginUserDetails = getDecryptedData();
const params = useParams()
  const [appointments, setAppointments] = useState([]);
  const [filteredAppointments, setFilteredAppointments] = useState([]);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [openDialog, setOpenDialog] = useState(false);
const navigate = useNavigate()
  useEffect(() => {
    const fetchAppointments = async () => {
      let endpoint = `/apis/default/api/patient/${params.pid}/appointment`;
      if (loginUserType === "Patient") {
        endpoint = `/apis/default/portal/patient/${loginUserDetails.pid}/appointment`;
      }
      try {
        const appointmentDataResponse = await ApiServices.get(endpoint, {
          Authorization: `Bearer ${accessToken}`,
        });
        setAppointments(appointmentDataResponse.data);
        setFilteredAppointments(appointmentDataResponse.data);
      } catch (error) {
        console.error("Error fetching appointments:", error);
      }
    };
    fetchAppointments();
  }, [accessToken, loginUserType, loginUserDetails.pid,params.pid]);

  useEffect(() => {
    let filtered = appointments?.filter((appt) =>
      appt.appointment_type?.toLowerCase().includes(search.toLowerCase())
    );
    if (statusFilter !== "All") {
      filtered = filtered.filter((appt) => appt.pc_apptstatus === statusFilter);
    }
    setFilteredAppointments(filtered);
  }, [search, statusFilter, appointments]);

  const consultationView = (appointment) => {
  const url = `/patient/consultation/${appointment.zoom_meeting_id}/${appointment.zoom_meeting_password}`;
  window.open(url, '_blank');
};

  return (
    <Box p={3}>
      {/* Top Controls */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <TextField
          label="Search by Appointment Type"
          variant="outlined"
          size="small"
          fullWidth
          sx={{ maxWidth: "400px" }}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <TextField
          select
          label="Filter by Status"
          variant="outlined"
          size="small"
          sx={{ minWidth: "200px", mx: 2 }}
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
        >
          <MenuItem value="All">All</MenuItem>
          <MenuItem value="APPR">Approved</MenuItem>
          <MenuItem value="^">Pending</MenuItem>
          <MenuItem value="REJ">Rejected</MenuItem>
        </TextField>
        <Button
          variant="contained"
          startIcon={<Add />}
          sx={{ bgcolor: "#05b6b3", color: "white" }}
          onClick={() => setOpenDialog(true)}
        >
          Book New Appointment
        </Button>
      </Box>

      {/* Appointment Cards */}
      <Grid container spacing={3}>
        {filteredAppointments.map((appt) => (
          <Grid item xs={12} sm={6} md={4} key={appt.pc_eid}>
            <Card sx={{ borderRadius: 2, boxShadow: 3, p: 2 }}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  {appt.appointment_type}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Appointment ID: {appt.pc_eid}
                </Typography>
                <Box display="flex" alignItems="center" mt={1}>
                  <Event fontSize="small" sx={{ mr: 1 }} />
                  <Typography variant="body2">{appt.pc_eventDate}</Typography>
                </Box>
                <Box display="flex" alignItems="center">
                  <AccessTime fontSize="small" sx={{ mr: 1 }} />
                  <Typography variant="body2">{appt.pc_startTime}</Typography>
                </Box>
                <Typography variant="body2" mt={1}>
                  Status: {statusLabels[appt.pc_apptstatus]} {statusIcons[appt.pc_apptstatus]}
                </Typography>
                <Box bgcolor="#f5f5f5" p={2} mt={2} borderRadius={2}>
                  <Typography variant="subtitle1">Billing Details</Typography>
                  <Divider sx={{ mb: 1 }} />
                  {appt.bill?.length > 0 ? (
                    appt.bill.map((bill) => (
                      <Typography key={bill.BillId} variant="body2">
                        {bill.BillId}: ${bill.Amount} - {bill.Status}
                      </Typography>
                    ))
                  ) : (
                    <Typography variant="body2" color="textSecondary">
                      No billing data available
                    </Typography>
                  )}
                </Box>
                <div style={{ display: "flex", justifyContent: "center", gap: "8px" }}>
  {appt.pc_apptstatus === "APPR" ? (
    <>
      {appt.is_virtual === 1 && (
        <Chip
          label="Join Consultation"
          color="success"
          clickable
          onClick={(e) => {
            e.stopPropagation();
            consultationView(appt);
          }}
          sx={{ mt: 2, cursor: "pointer" }}
        />
      )}
      <Chip
        label="Show Details"
        color="primary"
        clickable
        onClick={(e) => e.stopPropagation() || onAppointmentsClick(appt)}
        sx={{ mt: 2, cursor: "pointer" }}
      />
    </>
  ) : loginUserType === "patient" ? (
    <Chip
      label="Show Details"
      color="primary"
      disabled
      sx={{ mt: 2, cursor: "not-allowed", opacity: 0.6 }}
    />
  ) : ""}
</div>

              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Dialog for Booking New Appointment */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="xl" // Increase maxWidth to "xl"
  fullWidth
  PaperProps={{
    sx: { width: "90%", maxHeight: "90vh" }, // Custom width and height
  }}>
        <DialogTitle>
          Book New Appointment
          <IconButton
            aria-label="close"
            onClick={() => setOpenDialog(false)}
            sx={{ position: "absolute", right: 10, top: 10 }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <BookAppointment />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default AllBookedAppointments;
